import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mask'
})
export class MaskPipe implements PipeTransform {

  transform(value: string, showMask: boolean): string {
    //console.log(showMask);
    //console.log(value);
    if(typeof value !== "undefined"){
    if (!showMask || value.length != 9 ) {
      return value;
    }
    var displayValue=value.substring(5, value.length );
    var otpt='XXX-XX-' + displayValue;
    console.log(displayValue)  ;  
    console.log(value);
    return otpt;
  }
  return '';
  }
}
